import { useDispatch } from 'react-redux';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';

const useSendToSto = () => {
  const dispatch = useDispatch();

  const sendToSto = async (orderRef) => {
    if (!orderRef) {
      dispatch(
        setSnackBar({
          open: true,
          message: 'Reference commande manquante',
          color: 'error',
        })
      );
      return null;
    }

    try {
      let responseData = null;
      await AxiosConfig.create('post', `/orders/${orderRef}/sendToSto`)
        .call()
        .exit((res) => (responseData = res?.data));

      dispatch(
        setSnackBar({
          open: true,
          message:
            responseData?.message ||
            `Envoi en preparation lance pour ${orderRef}`,
          color: 'success',
        })
      );
      return responseData;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.errorMessage ||
        "Erreur lors de l'envoi en preparation";
      dispatch(
        setSnackBar({
          open: true,
          message: errorMessage,
          color: 'error',
        })
      );
      return null;
    }
  };

  return { sendToSto };
};

export default useSendToSto;
